import * as I18n from 'circe/I18n';
// getSku, getName, getTags, getTypeUOM, getTempClassification, getStackable
export const getSku = (original) => {
  try {
    return original.sku;
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};

export const getStandard = (original) => {
  try {
    const palletConfig = original.palletConfig;

    const keys = Object.keys(palletConfig).filter((s) => !/default|DEFAULT/.test(s));
    if (keys.length) {
      return keys.join(',');
    } else {
      return I18n.str('n/a', 'N/A');
    }
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};
export const getTags = (original) => {
  try {
    if (original?.tags?.length) {
      return original?.tags;
    }

    return [];
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};

export const getTypeUOM = (original) => {
  try {
    return original.typeUOM;
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};
export const getTempClassification = (original) => {
  try {
    return original.tempClassification;
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};

export const getName = (original) => {
  try {
    return original.name;
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};

export const getBarcode = (original) => {
  try {
    return original.barcode;
  } catch (e) {
    console.error(e);
    return I18n.str('notAvailable', 'N/A');
  }
};

export const formatFilters = (filters) => {
  const propertiesToSplit = ['name', 'barcode', 'tempClassification', 'typeUOM', 'tags', 'sku'];
  const updatedFilters = {};

  propertiesToSplit.forEach((property) => {
    if (filters[property]) {
      updatedFilters[property] = filters[property].split(/[, ]+/).map((value) => value.trim());
    }
  });

  return updatedFilters;
};

export const transformFormValues = (valuesSelector) => {
  const {
    sku,
    name,
    barcode,
    tags,
    defaultConfig,
    tempClassification,
    length,
    width,
    height,
    weight,
    typeUOM,
    stackable,
    palletConfig,
  } = valuesSelector;

  const formattedPalletConfigs = {};

  if (palletConfig?.length) {
    palletConfig.forEach((config, index) => {
      const standard = config.skuStandard || null;
      if (standard) {
        formattedPalletConfigs[standard] = {
          layers: parseFloat(config.layers) || 0,
          uomPerLayers: parseFloat(config.uomPerLayers) || 0,
          uomPerPallet: parseFloat(config.uomPerPallet) || 0,
        };
      }
    });
  }

  const parsedDefaultConfig = {
    layers: parseFloat(defaultConfig?.layers) || 0,
    uomPerLayers: parseFloat(defaultConfig?.uomPerLayers) || 0,
    uomPerPallet: parseFloat(defaultConfig?.uomPerPallet) || 0,
  };

  const formData = {
    sku,
    name,
    barcode,
    tags,
    tempClassification,
    dimensions: {
      height,
      length,
      width,
    },
    weight,
    typeUOM,
    domain: SYSTEM_DOMAIN,
    stackable,
    palletConfig: { ...formattedPalletConfigs, DEFAULT: { ...parsedDefaultConfig } },
  };

  return formData;
};
